import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { ColumnDefinition } from 'apps/sigma2-ui/src/components/ui/Table';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import React, { useMemo } from 'react';
import { getUnixTimestampAsReadableString } from 'libs/end-to-end/src/dates';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { UseRubricItemsDataPayload } from 'apps/sigma2-ui/src/data-wizard/components/use-rubric-items-data';
import { RubricBankItem } from 'libs/end-to-end/src/types/rubric-bank/rubric-bank-item';
import { S2Checkbox } from 'apps/sigma2-ui/src/components/ui/Checkbox';

export const DatabaseRubricBankItemsView = ({
  payload,
  isEditable,
}: {
  payload: UseRubricItemsDataPayload;
  isEditable: boolean;
}) => {
  const items = useMemo(() => {
    return payload.items;
  }, [payload]);

  const isLoading = useMemo(() => {
    return false;
  }, []);

  const isSelectable = useMemo(() => {
    return payload.singleSelectConfig !== null;
  }, [payload]);

  const columnDefinitions: ColumnDefinition<RubricBankItem>[] = useMemo(() => {
    const allItems: ColumnDefinition<RubricBankItem>[] = [];

    if (isSelectable) {
      allItems.push({
        id: 'select',
        header: () => <div>Select</div>,
        cell: ({ item }) => (
          <S2Checkbox
            checked={payload.singleSelectConfig?.currentItemId === item.id}
            onChange={() => {
              if (payload.singleSelectConfig) {
                payload.singleSelectConfig.setCurrentItemId(item.id);
              }
            }}
          >
            <></>
          </S2Checkbox>
        ),
      });
    }

    const baseItems: ColumnDefinition<RubricBankItem>[] = [
      {
        id: 'name',
        header: () => <div>Name</div>,
        cell: ({ item }) => <div>{item.name}</div>,
      },
      {
        id: 'createdAt',
        header: () => <div>Created At</div>,
        cell: ({ item }) => (
          <div>{getUnixTimestampAsReadableString(item.createdAt)}</div>
        ),
      },
      {
        id: 'updatedAt',
        header: () => <div>Updated At</div>,
        cell: ({ item }) => (
          <div>
            {item.updatedAt
              ? getUnixTimestampAsReadableString(item.updatedAt)
              : 'N/A'}
          </div>
        ),
      },
    ];

    allItems.push(...baseItems);

    if (isEditable) {
      allItems.push({
        id: 'modify',
        header: () => <div>Modify</div>,
        cell: ({ item }) => (
          <Spacing size={'sm'} direction={'horizontal'}>
            <Button
              behavior={{
                type: 'href',
                href: `/organizations/${payload.organizationId}/databases/${payload.databaseId}/rubric-bank-items/${item.id}`,
              }}
              size={'small'}
              variant={'outline'}
              disabled={isLoading}
              text={'Edit'}
            />
          </Spacing>
        ),
      });
    }

    return allItems;
  }, [payload, isSelectable, isEditable, isLoading]);

  return <Table items={items} columnDefinitions={columnDefinitions} />;
};
